module.exports = __webpack_public_path__ + "img/btn_TTS_pressed.52859871.png";